// extracted by mini-css-extract-plugin
export default {"hovered":"peer_hovered__tVe5c","bw_circle":"peer_bw_circle__mp2fd","bw_stars":"peer_bw_stars__MKLpK","stars":"peer_stars__nOGJu"};